import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React from "react"; //Limitless imports

import ClientContext from "../../../common/utils/client-context/ClientContext";
import { useTranslation } from "../../../common/hooks/translation/TranslationContext";
import { log as pilog } from "../../../common/utils";
import { validateCustomer } from "./CustomerValidator";
var UPDATE = "update";
var REPLACE = "replace";
export var INITIAL_CUSTOMER_STATE = {
  name: {
    value: "",
    pristine: true
  },
  email: {
    value: "",
    pristine: true
  },
  question: {
    value: "",
    pristine: true
  },
  mobileNumber: {
    value: "",
    pristine: true
  },
  customerEmailHash: "",
  fieldErrors: {},
  isFormInvalid: true,
  hiwViewed: false,
  emailViewed: false,
  shouldAutoSubmit: false,
  autoSubmittedQuestions: [],
  postHiwAction: ""
};

var getInitialCustomerState = function getInitialCustomerState(t, storageConfig) {
  var initialState = _objectSpread({}, INITIAL_CUSTOMER_STATE);

  if (storageConfig) {
    var log = pilog.getLogger("CustomerHook getInitialCustomerState");
    var localCustomer = storageConfig.getFromLocalStorage();

    try {
      initialState.name.value = localCustomer.user.name;
      initialState.name.pristine = false;
      initialState.email.value = localCustomer.user.email;
      initialState.email.pristine = false;
      initialState.customerEmailHash = localCustomer.user.customerEmailHash || "";
      initialState.hiwViewed = localCustomer.application.hiwViewed;
    } catch (_unused) {
      log.info("Failed to rehydrate customer");
    }
  }

  if (ClientContext._userName) {
    initialState.name.value = ClientContext._userName;
    initialState.name.pristine = false;
  }

  if (ClientContext._userEmail) {
    initialState.email.value = ClientContext._userEmail;
    initialState.email.pristine = false;
  }

  if (ClientContext._userQuestion) {
    initialState.question.value = ClientContext._userQuestion;
    initialState.question.pristine = false;
  }

  if (ClientContext._userMobile) {
    initialState.mobileNumber.value = ClientContext._userMobile;
    initialState.mobileNumber.pristine = false;
  }

  if (ClientContext._userName && ClientContext._userEmail && ClientContext._userQuestion) {
    initialState.shouldAutoSubmit = true;

    if (ClientContext._userMobileEnabled === "true" && !ClientContext._userMobile) {
      initialState.shouldAutoSubmit = false;
    }
  }

  ClientContext.validateQueryParameters("emailHash");

  if (ClientContext._emailHash) {
    initialState.customerEmailHash = ClientContext._emailHash;
  }

  var _validateCustomer = validateCustomer(initialState, t),
      isFormInvalid = _validateCustomer.isFormInvalid,
      fieldErrors = _validateCustomer.fieldErrors;

  initialState.isFormInvalid = isFormInvalid;
  initialState.fieldErrors = fieldErrors;
  return initialState;
};

var customerReducer = function customerReducer(state, action) {
  switch (action.type) {
    case REPLACE:
      return action.payload;

    case UPDATE:
      return _objectSpread({}, state, {}, action.payload);

    default:
      throw new Error("Unsupported customer action type");
  }
};

export var useCustomer = function useCustomer(storageConfig) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _React$useReducer = React.useReducer(customerReducer, getInitialCustomerState(t, storageConfig)),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      customer = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var updateCustomer = function updateCustomer(key, value) {
    var newCustomer = _objectSpread({}, customer, _defineProperty({}, key, {
      value: value,
      pristine: false
    })); //validate the new changes


    var _validateCustomer2 = validateCustomer(newCustomer, t),
        isFormInvalid = _validateCustomer2.isFormInvalid,
        fieldErrors = _validateCustomer2.fieldErrors;

    newCustomer.isFormInvalid = isFormInvalid;
    newCustomer.fieldErrors = fieldErrors;

    if (key === "mobileNumber") {
      var mobileNumber = value;

      if (mobileNumber.length > 0) {
        if (mobileNumber.charAt(0) !== "+") {
          newCustomer.mobileNumber.value = "+".concat(mobileNumber);
        }
      }
    }

    replaceAndSaveCustomer(newCustomer);
  };

  var replaceAndSaveCustomer = function replaceAndSaveCustomer(newCustomer) {
    dispatch({
      type: REPLACE,
      payload: newCustomer
    });

    if (storageConfig) {
      storageConfig.saveToLocalStorage({
        user: {
          name: newCustomer.name.value,
          email: newCustomer.email.value,
          customerEmailHash: newCustomer.customerEmailHash
        },
        application: {
          hiwViewed: newCustomer.hiwViewed
        }
      });
    }
  };

  var updateAutoSubmit = function updateAutoSubmit(shouldAutoSubmit) {
    dispatch({
      type: UPDATE,
      payload: {
        shouldAutoSubmit: shouldAutoSubmit
      }
    });
  };

  var updateCustomerEmailHashAndClearQuestion = function updateCustomerEmailHashAndClearQuestion(customerEmailHash) {
    clearQuestion({
      customerEmailHash: customerEmailHash
    });
  };

  var updateHIWViewedStatus = function updateHIWViewedStatus(value) {
    dispatch({
      type: UPDATE,
      payload: {
        hiwViewed: value,
        postHiwAction: ""
      }
    });
  };

  var updateEmailViewed = function updateEmailViewed(value) {
    dispatch({
      type: UPDATE,
      payload: {
        emailViewed: value
      }
    });
  };

  var addAutoSubmittedQuestion = function addAutoSubmittedQuestion(newQuestion) {
    dispatch({
      type: UPDATE,
      payload: {
        autoSubmittedQuestions: [].concat(_toConsumableArray(customer.autoSubmittedQuestions), [newQuestion])
      }
    });
  };

  var updatePostHiwAction = function updatePostHiwAction(newAction) {
    dispatch({
      type: UPDATE,
      payload: {
        postHiwAction: newAction
      }
    });
  };

  var isReturningCustomer = function isReturningCustomer() {
    if (customer.name.pristine || customer.email.pristine) {
      return false;
    } //checks to see if all the customer details are present and correct (excluding question)


    var _validateCustomer3 = validateCustomer(customer, t, true),
        isFormInvalid = _validateCustomer3.isFormInvalid;

    return !isFormInvalid;
  };

  var isCustomerQuestionValid = function isCustomerQuestionValid() {
    var _validateCustomer4 = validateCustomer(customer, t, false),
        isFormInvalid = _validateCustomer4.isFormInvalid;

    return !isFormInvalid;
  };

  var getCustomerData = function getCustomerData() {
    return {
      name: customer.name.value,
      email: customer.email.value,
      question: customer.question.value,
      mobileNumber: customer.mobileNumber.value
    };
  };

  var clearQuestion = function clearQuestion() {
    var extraState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newCustomer = _objectSpread({}, extraState);

    newCustomer.question = {
      value: "",
      pristine: true
    };
    newCustomer.isFormInvalid = true;
    dispatch({
      type: UPDATE,
      payload: newCustomer
    });
  };

  return {
    customer: customer,
    updateCustomer: updateCustomer,
    clearQuestion: clearQuestion,
    getCustomerData: getCustomerData,
    updateHIWViewedStatus: updateHIWViewedStatus,
    updateEmailViewed: updateEmailViewed,
    updateCustomerEmailHashAndClearQuestion: updateCustomerEmailHashAndClearQuestion,
    isReturningCustomer: isReturningCustomer,
    isCustomerQuestionValid: isCustomerQuestionValid,
    addAutoSubmittedQuestion: addAutoSubmittedQuestion,
    replaceAndSaveCustomer: replaceAndSaveCustomer,
    updateAutoSubmit: updateAutoSubmit,
    updatePostHiwAction: updatePostHiwAction
  };
};